import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const QuoteTabsStyle = styled('div')`
    background: var(--white);
    padding-top: 24px;

    .tabs {
        display: flex;
        background: var(--white);
        border: 1px solid var(--sand-400);
        border-radius: 6px;
        overflow: hidden;
    }

    .tab {
        flex: 1 1 0;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 42px;
        padding: 6px 12px;
        text-align: center;
        color: var(--sand-700);
        ${typography.buttonMd}
        text-decoration-line: none;
        border-bottom: 2px solid transparent;

        &:hover {
            color: var(--orange-300);
        }

        &.active {
            border-bottom-color: var(--orange-300);
        }
    }

    ${media.mobile} {
        padding-top: 0;

        .container-ydp {
            padding-left: 0;
            padding-right: 0;
        }

        .tabs {
            border-width: 0 0 1px;
            border-radius: 0;
            justify-content: space-between;
        }

        .tab {
            flex: 0 1 auto;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 14px;
            line-height: normal;
        }
    }
`;

export default QuoteTabsStyle;
